import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import GameLineMarketContent from 'modules/aggregated-market-pane/game-line/index.js';
import { useMarketItems } from 'modules/common/hooks';

const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;

const EventsUtils = MojitoServices.SportsContent.Events.utils;
const { utils: MarketGroupUtils } = MojitoServices.SportsContent.MarketGroups;
const { createAggregatedMarket } = EventsUtils;
const { createGameLineMarketInfo } = MarketGroupUtils;

const GameLine = props => {
    const { mojitoTools, event, gameLine, marketLines, onEventClick, config } = props;
    const { appContext } = mojitoTools;

    const gameLineMarketInfo = createGameLineMarketInfo(marketLines, gameLine);
    const marketIds = gameLineMarketInfo.markets.map(market => market?.id).filter(Boolean);
    const markets = useMarketItems(marketIds);

    return (
        <GameLineMarketContent
            config={config}
            eventItem={event}
            aggregatedMarket={createAggregatedMarket(gameLineMarketInfo, markets)}
            onEventClick={onEventClick}
            hrefLink={NavigationPathBuilder.sportEventPath(
                event.sportId,
                event.id,
                appContext.routeResolver
            )}
        />
    );
};

export default GameLine;
